/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewBreachSourceItem
 */
export interface CRSFSecReviewBreachSourceItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewBreachSourceItem
     */
    features: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBreachSourceItem
     */
    fullname?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewBreachSourceItem interface.
 */
export function instanceOfCRSFSecReviewBreachSourceItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "features" in value;

    return isInstance;
}

export function CRSFSecReviewBreachSourceItemFromJSON(json: any): CRSFSecReviewBreachSourceItem {
    return CRSFSecReviewBreachSourceItemFromJSONTyped(json, false);
}

export function CRSFSecReviewBreachSourceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewBreachSourceItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'features': json['features'],
        'fullname': !exists(json, 'fullname') ? undefined : json['fullname'],
    };
}

export function CRSFSecReviewBreachSourceItemToJSON(value?: CRSFSecReviewBreachSourceItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'features': value.features,
        'fullname': value.fullname,
    };
}

